import React from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup, Label, Input,
} from 'reactstrap';
import {
  regexPattern, staticConstants, NUMERIC_VALUE, GRAPH_CONST_VALUES,
} from '../../../utils';
import { Country, State } from '../../shared/region';

function RenderTopStates(props) {
  const {
    errors, register, formData, handleCountryChange, handleStateChange,
  } = props;

  const renderTopStates = (count, country, state, inputName) => (
    <FormGroup className={`input-field field-group
    ${errors[inputName] && `${staticConstants.ERROR_CLASS.FORM_ERROR}`}`}
    >
      <div className="form-group-col">
        <Label
          for="country"
        >
          Country
          {' '}
          {count}
        </Label>
        <Country
          onChange={(event) => { handleCountryChange(event, country, state); }}
          value={formData[country]}
        />
      </div>
      <div className="form-group-col">
        <Label
          for="city"
        >
          State
          {' '}
          {count}
        </Label>
        <State
          onChange={(event) => { handleStateChange(event, state); }}
          country={formData[country]}
          value={formData[state]}
        />
        <Input
          type="text"
          name={inputName}
          data-label="city"
          value={formData[inputName]}
          placeholder="%"
          innerRef={register({
            pattern: {
              value: regexPattern.NUMBER_ZERO_TO_HUNDRED_DECIMAL,
            },
          })}
        />
      </div>
    </FormGroup>
  );

  return (
    <>
      {renderTopStates(
        NUMERIC_VALUE.ONE, GRAPH_CONST_VALUES.STATE_COUNTRY_ONE, GRAPH_CONST_VALUES.STATE_ONE, GRAPH_CONST_VALUES.STATE_FOLLOWERS_ONE,
      )}
      {renderTopStates(
        NUMERIC_VALUE.TWO, GRAPH_CONST_VALUES.STATE_COUNTRY_TWO, GRAPH_CONST_VALUES.STATE_TWO, GRAPH_CONST_VALUES.STATE_FOLLOWERS_TWO,
      )}
      {renderTopStates(
        NUMERIC_VALUE.THREE, GRAPH_CONST_VALUES.STATE_COUNTRY_THREE, GRAPH_CONST_VALUES.STATE_THREE, GRAPH_CONST_VALUES.STATE_FOLLOWERS_THREE,
      )}
      {renderTopStates(
        NUMERIC_VALUE.FOUR, GRAPH_CONST_VALUES.STATE_COUNTRY_FOUR, GRAPH_CONST_VALUES.STATE_FOUR, GRAPH_CONST_VALUES.STATE_FOLLOWERS_FOUR,
      )}
      {renderTopStates(
        NUMERIC_VALUE.FIVE, GRAPH_CONST_VALUES.STATE_COUNTRY_FIVE, GRAPH_CONST_VALUES.STATE_FIVE, GRAPH_CONST_VALUES.STATE_FOLLOWERS_FIVE,
      )}
    </>
  );
}

RenderTopStates.propTypes = {
  errors: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
  handleStateChange: PropTypes.func.isRequired,
  handleCountryChange: PropTypes.func.isRequired,
};

export default RenderTopStates;
